module.exports = __webpack_public_path__ + "img/r2.57dc6e6d.jpg";